export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c75b65d0-41cd-4fe6-8437-1aeecae348e2';
export const MODAL_CLOSE_SEC = 2.5;
